export const getColor = (hue: number, saturation: number, lightness: number) =>
  `hsl(${hue}, ${saturation}%, ${lightness}%)`

const black = (lightness: number) => {
  switch (lightness) {
    case 98:
      return getColor(210, 20, lightness)
    case 94:
      return getColor(220, 20, lightness)
    case 15:
      return getColor(218, 11, lightness)
    default:
      return getColor(225, 20, lightness)
  }
}

const lobster = (lightness: number) => {
  switch (lightness) {
    case 98:
      return getColor(354, 100, lightness)
    case 90:
      return getColor(355, 96, lightness)
    default:
      return getColor(355, 95, lightness)
  }
}

const blue = (lightness: number) => {
  switch (lightness) {
    case 96:
      return getColor(227, 90, lightness)
    case 94:
      return getColor(226, 94, lightness)
    case 90:
      return getColor(227, 92, lightness)
    case 60:
      return getColor(227, 93, lightness)
    default:
      return getColor(227, 93, lightness)
  }
}

const palette = {
  white: getColor(0, 0, 100),
  black,
  blue,
  basil: (lightness: number) => getColor(275, 80, lightness),
  lobster
} as const

export default palette
